"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthInDTO = void 0;
class AuthInDTO {
    identifier;
    password;
}
exports.AuthInDTO = AuthInDTO;
